import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@trovata/environments/environment';
import { StablecoinWorkflow, StablecoinWorkflowCreate } from '../../models/workflow.model';
import { StablecoinApprovalDecisionValue } from '../../models/transfer.model';

/**
 * Low-level HTTP service for stablecoin payment workflows.
 * State/components should use StablecoinWorkflowsFacadeService instead.
 */
@Injectable({
	providedIn: 'root',
})
export class StablecoinWorkflowsHttpService {
	private readonly http: HttpClient = inject(HttpClient);
	private readonly baseUrl: string = environment.stablecoinAPI();

	getWorkflows(): Observable<StablecoinWorkflow[]> {
		return this.http.get<StablecoinWorkflow[]>(`${this.baseUrl}/workflows`);
	}

	createWorkflow(body: StablecoinWorkflowCreate): Observable<StablecoinWorkflow> {
		return this.http.post<StablecoinWorkflow>(`${this.baseUrl}/workflows`, body);
	}

	/**
	 * Edits a workflow. Editing a live workflow returns a NEW pending_approval workflow superseding it;
	 * editing a pending or rejected workflow updates it in place and resets it to pending_approval.
	 */
	updateWorkflow(workflowId: string, body: StablecoinWorkflowCreate): Observable<StablecoinWorkflow> {
		return this.http.put<StablecoinWorkflow>(`${this.baseUrl}/workflows/${workflowId}`, body);
	}

	decideWorkflow(workflowId: string, decision: StablecoinApprovalDecisionValue, comment?: string): Observable<StablecoinWorkflow> {
		return this.http.post<StablecoinWorkflow>(`${this.baseUrl}/workflows/${workflowId}/decide`, { decision, comment: comment ?? null });
	}

	archiveWorkflow(workflowId: string): Observable<StablecoinWorkflow> {
		return this.http.delete<StablecoinWorkflow>(`${this.baseUrl}/workflows/${workflowId}`);
	}
}
